import { render, staticRenderFns } from "./couponAdd.vue?vue&type=template&id=5350252c"
import script from "./couponAdd.vue?vue&type=script&lang=js"
export * from "./couponAdd.vue?vue&type=script&lang=js"
import style0 from "./couponAdd.vue?vue&type=style&index=0&id=5350252c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports